<template>
  <svg viewBox="0 0 63 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.4699 38.0493C22.7835 37.6139 22.9777 37.2827 23.2234 37.0063C33.7231 25.2955 44.2346 13.5926 54.7296 1.87399C56.0143 0.439801 57.4558 -0.342481 59.2927 0.145142C62.5875 1.01869 63.8651 5.35253 61.6842 8.24176C61.4783 8.51556 61.2443 8.76328 61.0173 9.01622C49.3569 22.0125 37.6965 35.0089 26.0361 48.0052C23.654 50.6597 21.1688 50.6649 18.7984 48.0208C13.0185 41.58 7.23393 35.1471 1.46341 28.6958C-1.07787 25.8562 -0.179295 21.3424 3.15291 20.2263C4.97346 19.6161 6.52724 20.2055 7.85872 21.6944C11.6472 25.937 15.4545 30.1587 19.2477 34.3961C20.2773 35.546 21.2929 36.7142 22.4699 38.0493Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'check',
}
</script>
